import "./index.css";
import BaseViewmodel from "@nectari/shared/base-viewmodel";
import { ensureHtmlElement } from "@nectari/utils/html";

export default class LoginAdvancedError extends BaseViewmodel {
    #browserTabId;
    #id = "login-advanced-error";
    #errorMessage;
    #errorId;
    #onClosed;

     constructor(browserTabId, errorMessage, errorId) {
        super();
        this.#browserTabId = browserTabId;
        this.#errorMessage = errorMessage;
        this.#errorId = errorId;
    };

    async initialize() {
        let response;

        try
        {
            response = await fetch(`${BINamespace.getPathUrl()}/Proxyless/GetLoginAdvancedError/${this.#browserTabId}`);
        } 
        catch(error) {
            this.#close();
            return;
        }

        if (!response.ok)
        {
            this.#close();
            return;
        }

        const modal = document.createElement("dialog");
        modal.id = this.#id;
        modal.innerHTML = await response.text();
        document.body.appendChild(modal);
        modal.showModal();

        const errorIdElem = ensureHtmlElement(
            modal.querySelector("#advancedErrorID")
        );

        const errorMessage = ensureHtmlElement(
            modal.querySelector("#advancedErrorMessage")
        );

        errorMessage.innerHTML = this.#errorMessage;
        errorIdElem.innerHTML = `${BINamespace.loginLabels.STR_ERROR_ID} ${this.#errorId}`;

        const copyErrorMessageBtn = ensureHtmlElement(
            modal.querySelector("#copyErrorMessage")
        );

        copyErrorMessageBtn.addEventListener(
            "click",
            () => this.#copyErrorMessage(),
            {
                signal: this.abortSignal,
            },
        );

        const closeDialog = ensureHtmlElement(
            modal.querySelector(".closeDialog")
        );

        closeDialog.addEventListener(
            "click",
            () => this.#close(),
            {
                signal: this.abortSignal,
            },
        );

        // This promise will only be resolved when the user closes the popup, 
        // this way we can wait until it's closed before doing other stuff on the login page.
        const {promise, resolve} = Promise.withResolvers();
        this.#onClosed = resolve;

        return promise;
    }

    #copyErrorMessage() {
        const errorMessage = $(`#${this.#id}`).find("#advancedErrorMessage")[0].innerHTML;
        navigator.clipboard.writeText(errorMessage);
    }

    #close() {
        const dialogElement = document.getElementById(this.#id);

        if (dialogElement instanceof HTMLDialogElement) {
            dialogElement.close();
            dialogElement.remove();
        }

        this.destroy();
        this.#onClosed();
    }
}